export const DEADLINE_PASSED_ERROR = "The deadline to submit a Claim has passed.";

/**
 * Resolve the member record from classMemberPost result.data. No-claim
 * responses are the member itself; existing-claim responses nest it under
 * class_member. A present class_member key is authoritative, even when null
 * or malformed, so top-level flags cannot override it.
 *
 * @param {*} memberResult - classMemberPost result.data.
 * @returns {*} The member record to evaluate.
 */
function claimantRecord(memberResult) {
    if (memberResult === null || typeof memberResult !== "object") return;
    return "class_member" in memberResult
        ? memberResult.class_member
        : memberResult;
}

/**
 * Claimant-level claim-form access. Fails closed: both flags on the member
 * record must be strictly numeric 1.
 *
 * @param {*} memberResult - classMemberPost result.data.
 * @returns {boolean}
 */
export function canAccessClaimForm(memberResult) {
    const member = claimantRecord(memberResult);
    return (
        member?.can_view_claim_form === 1 && member?.can_edit_claim_form === 1
    );
}

/**
 * Gate populate_claim_form, the point where the guard-submit and OTP paths
 * converge. Denied members get the existing deadline-passed presentation;
 * authentication and site access are untouched.
 *
 * @param {typeof import("commonAssets/components/Forms/SubmitClaim").SubmitClaim} Base
 * @returns {Function} Subclass of Base.
 */
export function withClaimFormGate(Base) {
    return class extends Base {
        populate_claim_form(form, container, class_member, claim_deadline) {
            if (!canAccessClaimForm(class_member)) {
                this.setup_result_data_error({
                    data: { error: DEADLINE_PASSED_ERROR },
                });
                return;
            }
            super.populate_claim_form(
                form,
                container,
                class_member,
                claim_deadline
            );
        }
    };
}
